<template>
    <div v-if="visible" class="am-card">

        <div class="am-head">
            <div class="am-head__main">
                <span class="am-head__icon"><i class="ri-alarm-warning-line"></i></span>
                <div>
                    <h4 class="am-title">Matières premières en alerte <span class="am-count">{{ matieres.length }}</span></h4>
                    <p class="am-sub">
                        Stock nul, négatif ou sous le minimum. Information seulement : la vente n'est jamais bloquée.
                        <template v-if="facturesEnAttente>0"> {{ facturesEnAttente }} facture(s) en attente de déstockage.</template>
                    </p>
                </div>
            </div>
            <div class="am-actions">
                <button @click="load" :disabled="loading" type="button" class="cf-iconbtn" title="Actualiser"><i class="ri-refresh-line"></i></button>
                <button @click="replie=!replie" type="button" class="cf-iconbtn" :title="replie ? 'Afficher' : 'Réduire'">
                    <i :class="replie ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'"></i>
                </button>
            </div>
        </div>

        <div v-if="!replie" class="am-scroll">
            <table class="am-table">
                <thead>
                <tr>
                    <th class="th">Matière première</th>
                    <th class="th">Entrepôt</th>
                    <th class="th th--right">Stock</th>
                    <th class="th th--right">Stock minimum</th>
                    <th v-if="avecAttente" class="th th--right" title="Plats vendus dont les matières ne sont pas encore sorties du stock">En attente de déstockage</th>
                    <th v-if="avecAttente" class="th th--right">Stock prévu</th>
                    <th class="th">État</th>
                </tr>
                </thead>
                <tbody>
                <tr class="table-row" v-for="matiere in matieres" :key="matiere.pid+'|'+matiere.pidmag">
                    <td class="td cf-strong">{{ matiere.libelle }}</td>
                    <td class="td">{{ matiere.magasin || '-' }}</td>
                    <td class="td td--right cf-strong" :class="{ 'am-ko': matiere.stock<=0 }">{{ formatQte(matiere.stock) }} <small>{{ matiere.unite }}</small></td>
                    <td class="td td--right">{{ matiere.stockminimum>0 ? formatQte(matiere.stockminimum) : '-' }}</td>
                    <td v-if="avecAttente" class="td td--right">{{ matiere.enAttente>0 ? formatQte(matiere.enAttente) : '-' }}</td>
                    <td v-if="avecAttente" class="td td--right" :class="{ 'am-ko': matiere.stockPrevu<=0 }">{{ formatQte(matiere.stockPrevu) }}</td>
                    <td class="td">
                        <span v-if="matiere.niveau==='rupture'" class="am-st am-st--ko">{{ matiere.stock<0 ? 'Stock négatif' : 'Rupture' }}</span>
                        <span v-else-if="matiere.niveau==='attente'" class="am-st am-st--warn">Épuisé par les commandes en cours</span>
                        <span v-else class="am-st am-st--warn">Sous le minimum</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "alertesmatieres",

        props:{
            pidmag:{ type:String, default:"" },
            autoload:{ type:Boolean, default:true },
        },

        computed:{
            visible(){
                return this.matieres.length>0;
            },
            avecAttente(){
                return this.matieres.some(function (matiere) { return matiere.enAttente>0 });
            },
        },

        data() {
            return {
                loading:false,
                replie:false,
                matieres:[],
                facturesEnAttente:0,
            };
        },

        watch:{
            pidmag(){
                this.load();
            },
        },

        mounted(){
            if (this.autoload) this.load();
        },

        methods: {

            formatQte(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:3});
            },

            /* Silencieux : ce panneau est une information annexe, une panne ne doit pas gêner l'écran hôte. */
            async load(){

                const t = this;
                this.loading=true;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/alertes/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{pidmag:this.pidmag},{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (res.data.success){
                        t.matieres=res.data.m.matieres || [];
                        t.facturesEnAttente=res.data.m.facturesEnAttente || 0;
                    }

                }catch (error) {
                    t.matieres=[];
                }

                this.loading=false;

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.am-card { background:#fff; border:1px solid var(--cf-border); border-left:4px solid #f97316; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-sm, none); margin-bottom:1rem; overflow:hidden; }
.am-head { display:flex; align-items:center; justify-content:space-between; gap:0.75rem; padding:0.8rem 1rem; }
.am-head__main { display:flex; align-items:center; gap:0.75rem; min-width:0; }
.am-head__icon { height:2.25rem; width:2.25rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); background:#ffedd5; color:#ea580c; font-size:1.15rem; }
.am-title { margin:0; font-size:0.92rem; font-weight:700; color:var(--cf-ink-strong); }
.am-count { display:inline-block; margin-left:0.35rem; padding:0 0.5rem; border-radius:999px; background:#fee2e2; color:#b91c1c; font-size:0.75rem; font-weight:700; }
.am-sub { margin:2px 0 0; font-size:0.76rem; color:var(--cf-muted); white-space:normal; }
.am-actions { display:flex; gap:0.4rem; flex-shrink:0; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:1px solid var(--cf-border); background:#fff; color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-iconbtn:hover { color:rgb(var(--primary)); border-color:rgb(var(--primary)); }
.cf-iconbtn:disabled { opacity:0.5; cursor:default; }

.am-scroll { overflow:auto; max-height:320px; border-top:1px solid var(--cf-border); }
.am-table { width:100%; text-align:left; border-collapse:collapse; min-width:640px; }
.th { position:sticky; top:0; z-index:1; padding:0.55rem 0.75rem; font-weight:600; font-size:0.74rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; text-align:left; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.45rem 0.75rem; font-size:0.8rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td small { font-size:0.7rem; font-weight:400; color:var(--cf-muted); }
.td--right { text-align:right; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }
.td.am-ko { color:#b91c1c; }
.am-st { display:inline-block; padding:2px 8px; border-radius:999px; font-size:0.72rem; font-weight:600; }
.am-st--ko { background:#fee2e2; color:#b91c1c; }
.am-st--warn { background:#fef9c3; color:#a16207; }
</style>
